import {
  DesignSubmittalStatus,
  SharePointParentFolder,
  Permission,
} from 'shared'
import {
  DesignSubmittal,
  useDesignSubmittalLogContext,
} from '../../../../DesignSubmittalLogContext'
import { CustomRowActionOptions } from 'components/CIMSTable/CIMSTableContext/types/actions/row'
import {
  useLockRowActionButton,
  useUnlockRowActionButton,
} from 'components/CIMSTable/common/hooks/useLockUnlock'

export function useCustomRowOptions(): CustomRowActionOptions<DesignSubmittal>[] {
  const {
    refetch,
    revertModal: { toggle },
    repair,
  } = useDesignSubmittalLogContext()
  const { Unlocked, ReturnedToDesignBuilder } = DesignSubmittalStatus
  const lock = useLockRowActionButton<DesignSubmittal>({
    refetch,
    parent: SharePointParentFolder.DesignSubmittals,
    hidden: ({ status, deleted }) =>
      deleted || (status as DesignSubmittalStatus) !== Unlocked,
  })
  const unlock = useUnlockRowActionButton<DesignSubmittal>({
    refetch,
    parent: SharePointParentFolder.DesignSubmittals,
    hidden: ({ status, deleted }) =>
      deleted || (status as DesignSubmittalStatus) !== ReturnedToDesignBuilder,
  })
  return [
    {
      text: 'Revert',
      permission: Permission.RevertDesignSubmittal,
      disabled: ({ status }) =>
        status === DesignSubmittalStatus.ReturnedToDesignBuilder
          ? {
              message: `Cannot be reverted while in status: ${DesignSubmittalStatus.ReturnedToDesignBuilder}`,
            }
          : false,
      hidden: ({ status, deleted }) =>
        deleted ||
        status === DesignSubmittalStatus.DisciplineAction ||
        status === DesignSubmittalStatus.RouterReview,
      onClick: (record) => toggle(record),
    },
    lock,
    unlock,
    repair,
  ]
}
